import { RoutesService, eLayoutType } from '@abp/ng.core';
import { eThemeSharedRouteNames } from '@abp/ng.theme.shared';
import { APP_INITIALIZER } from '@angular/core';
import { Constants } from './warr/common/constants';

export const APP_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  let role = localStorage.getItem(Constants.LocalKey.CurrentRoles);
  return () => {
    routes.add([
      {
        path: '/',
        name: 'WARR::Menu:Home',
        iconClass: 'fas fa-home',
        order: 0,
        layout: eLayoutType.application,
        invisible: true,
      },
      {
        path: 'reports/dashboard/manager',
        name: 'WARR::Menu:Dashboard',
        iconClass: 'fa fa-line-chart',
        order: 1,
        requiredPolicy: 'WARR.AccessWeb',
      },
      {
        path: 'reports/dashboard/manager',
        name: 'WARR::Menu:Dashboard',
        iconClass: 'fa fa-line-chart',
        order: 1,
        requiredPolicy: 'WARR.WarrReport.WarrReportDashboardManager',
      },
      {
        path: 'reports/dashboard/casper-center',
        name: 'WARR::Menu:Dashboard1',
        iconClass: 'fa fa-line-chart',
        order: 2,
        requiredPolicy: 'WARR.AccessWeb',
      },
      {
        path: 'reports/dashboard/casper-center',
        name: 'WARR::Menu:Dashboard1',
        iconClass: 'fa fa-line-chart',
        order: 2,
        requiredPolicy: 'WARR.WarrReport.WarrReportDashboardCasperCenter',
      },
      {
        path: 'reports/dashboard/service-center',
        name: 'WARR::Menu:Dashboard2',
        iconClass: 'fa fa-line-chart',
        order: 3,
        requiredPolicy: 'WARR.AccessWeb',
      },
      {
        path: 'reports/dashboard/service-center',
        name: 'WARR::Menu:Dashboard2',
        iconClass: 'fa fa-line-chart',
        order: 3,
        requiredPolicy: 'WARR.WarrReport.WarrReportDashboardServiceCenter',
      },
      {
        path: 'reports/dashboard/station',
        name: 'WARR::Menu:WarrReportDashboardKPIStation',
        iconClass: 'fa fa-line-chart',
        order: 4,
        requiredPolicy: 'WARR.WarrReport.WarrReportDashboardKPIStation',
      },
      {
        path: 'warr',
        name: 'WARR::Menu:WARR',
        iconClass: 'fa fa-shield',
        order: 5,
        requiredPolicy: 'WARR.AccessWeb'
      },
      {
        path: 'warr-accessory-request',
        name: 'WARR::Menu:WarrAccessoryRequest',
        iconClass: 'fa fa-cogs',
        order: 5,
        requiredPolicy: 'WARR.AccessWeb'
      },
      {
        path: '/service-center/inventory-data',
        name: 'WARR::Menu:WarrServiceCenter',
        iconClass: 'fa fa-warehouse',
        order: 6,
        requiredPolicy: 'WARR.ServiceCenterData'
      },
      {
        path: 'warr-accessory-recall',
        name: 'WARR::Menu:WarrAccessoryRecall',
        iconClass: 'fa fa-cubes',
        order: 7,
        requiredPolicy: 'WARR.AccessWeb'
      },
      {
        path: 'warr-category',
        name: 'WARR::Menu:WarrCategory',
        iconClass: 'fa fa-list-alt',
        order: 8,
        requiredPolicy: 'WARR.AccessWeb'
      },
      {
        path: 'warr-configuration',
        name: 'WARR::Menu:WarrConfiguration',
        iconClass: 'fa fa-user-cog',
        order: 9,
        requiredPolicy: 'WARR.AccessWeb'
      },
      {
        path: 'identity',
        name: 'WARR::Menu:WarrEmployee',
        iconClass: 'fa fa-address-book-o',
        order: 10,
        requiredPolicy: 'WARR.AccessWeb'
      },
      {
        path: 'warr-report',
        name: 'WARR::Menu:WarrReport',
        iconClass: 'fa fa-flag',
        order: 11,
        requiredPolicy: 'WARR.AccessWeb',
      },
      {
        path: eThemeSharedRouteNames.Administration,
        name: eThemeSharedRouteNames.Administration,
        iconClass: 'fa fa-wrench',
        requiredPolicy: 'WARR.AccessWeb',
        invisible: role != 'admin' ? true : false,
      }
    ]);
  };
}
